__webpack_require__.p = "/apps/text/js/";